// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2DouF","errorLogs":"styles_errorLogs__304NO"};